import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { AppHelper } from '../helpers/AppHelper';

export const VenueSummary2 = ({
  item,
  site,
  deviceCodeNode,
  compact = false,
  showVenueTitle = true,
  showScreenType = true,
  showSerialNumber = true,
  showScreenPlacement = true,
  showArchived = true,
  showNotRegistered = true,
  showTesting = true,
  showExtId = true
}) => {
  const current = item || {}
  const siteInfo = site || current.site || current.siteInfo
  const title = (siteInfo && siteInfo.title) || (current.info && current.info.title)
  const address = (siteInfo && siteInfo.address) || (current.info && current.info.address)
  const serialNumber = current.latestDeviceFeed && current.latestDeviceFeed.serialnumber
    ? current.latestDeviceFeed.serialnumber
    : current.serialNumber
  const showSerial = showSerialNumber &&
    serialNumber &&
    typeof serialNumber === 'string' &&
    serialNumber.toLowerCase() !== 'unknown'
  const normalizedVenueTitle = current.title && current.title.trim().toLowerCase()
  const normalizedSiteTitle = title && title.trim().toLowerCase()
  const shouldShowVenueTitle = showVenueTitle && current.title && normalizedVenueTitle !== normalizedSiteTitle
  const screenDimension = (current.info && current.info.screenDimension)
  const screenBrand = (current.info && current.info.screenBrand)
  const screenModel = (current.info && current.info.screenModel)
  const category = (current.info && current.info.category)
  const pricingTier = (current.info && current.info.pricingTier)
  const screenSpecs = [
    showScreenType && current.info && current.info.openoohcategory && `Type: ${current.info.openoohcategory}`,
    showScreenPlacement && current.info && current.info.screenPlacement && `Placement: ${current.info.screenPlacement}`,
    screenDimension && `Dimension: ${screenDimension}`
  ].filter(Boolean).join(' | ')
  const screenModelBrandPricing = [
    screenModel && `Model: ${screenModel}`,
    screenBrand && `Brand: ${screenBrand}`,
    pricingTier && `Pricing Tier: ${pricingTier}`
  ].filter(Boolean).join(' | ')
  const deviceInfo = [
    showSerial && `SN: ${serialNumber}`,
    !deviceCodeNode && current.deviceCode
  ].filter(Boolean).join(' | ')

  return (
    <div className={css(Styles.container, compact && Styles.compactContainer)}>
      {/* <pre>
        {JSON.stringify(current,null,2)}
      </pre> */}
      {title &&
        <div>
          <span className={css(Styles.storeNameText, compact && Styles.compactStoreNameText, Styles.truncateLine)}>{title}</span>
        </div>
      }
      {address &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>{address}</span>
        </div>
      }
      {compact && screenSpecs &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>{screenSpecs}</span>
        </div>
      }
      {compact && screenModelBrandPricing &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>{screenModelBrandPricing}</span>
        </div>
      }
      {compact && category &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>Category: {current.info.category}</span>
        </div>
      }
      {compact && (deviceCodeNode || deviceInfo) &&
        <div>
          <span className={css(Styles.line2, Styles.truncateLine, compact && Styles.compactLine2)}>{deviceCodeNode || deviceInfo}</span>
        </div>
      }

      {/* Non Compact UI */}
      {!compact && screenSpecs &&
        <div>
          <span className={css(Styles.line2)}>{screenSpecs}</span>
        </div>
      }
      {!compact && screenModelBrandPricing &&
        <div>
          <span className={css(Styles.line2)}>{screenModelBrandPricing}</span>
        </div>
      }
      {!compact && category &&
        <div>
          <span className={css(Styles.line2)}>Category: {category}</span>
        </div>
      }
      {!compact && (deviceCodeNode || deviceInfo) &&
        <div>
          <span className={css(Styles.line2)}>{deviceCodeNode || deviceInfo}</span>
        </div>
      }
      {/* ------ */}
      {shouldShowVenueTitle &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>{current.title}</span>
        </div>
      }
      {showArchived && current.state === 'ARCHIVED' &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>ARCHIVED</span>
        </div>
      }
      {showNotRegistered && !current.installationId && !AppHelper.isNonApkDevice(current) &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>NOT REGISTERED</span>
        </div>
      }
      {showTesting && current.testing === 'YES' &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>TESTING(NOT SSP)</span>
        </div>
      }
      {showExtId && current.extId &&
        <div>
          <span className={css(Styles.line2, compact && Styles.compactLine2, Styles.truncateLine)}>EXTID: {current.extId}</span>
        </div>
      }
    </div>
  )
}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  compactContainer: {
    gap: 1
  },
  storeNameText: {
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  compactStoreNameText: {
    fontSize: '14px',
    lineHeight: '18px'
  },
  line2: {
    fontSize: 12
  },
  compactLine2: {
    fontSize: 11,
    lineHeight: '16px'
  },
  truncateLine: {
    display: 'block',
    maxWidth: '100%',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere'
  }
})



// WEBPACK FOOTER //
// ./src/components/VenueSummary2.js